import styled from 'styled-components';

const btnSquare = '28px';

export const SVG = styled.svg`
  box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.1);
  border-radius: 100%;
  height: ${btnSquare};
  position: relative;
  width: ${btnSquare};

  .open & {
    box-shadow: inset 0 0 0 3px rgba(0, 0, 0, 0.1);
  }
`;

export const Circle = styled.circle`
  fill: rgba(0, 0, 0, 0);
  stroke: ${props => props.theme.colors.tertiary};
  stroke-width: 8px;
  stroke-linecap: round;
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  transition: fill ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeInOut},
    stroke-dashoffset ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeInOut};
  transform-origin: 50% 50%;

  .open & {
    stroke: ${props => props.theme.colors.white};
  }
`;

const HeaderNavToggleStyled = styled.button`
  background: ${props => props.theme.colors.white};
  border: 0;
  border-radius: 100%;
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  cursor: pointer;
  outline: 0;
  padding: 0;
  position: absolute;
  height: ${btnSquare};
  right: 25px;
  top: 25px;
  width: ${btnSquare};
  z-index: ${props => props.theme.zIndex.navToggle};
  transition: transform ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeInOut},
    box-shadow ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeInOut};

  &::before {
    background: rgba(255, 255, 255, 0);
    border-radius: 100%;
    bottom: 0;
    color: ${props => props.theme.colors.tertiary};
    content: '?';
    font-family: ${props => props.theme.fonts.primary};
    font-size: 12px;
    font-weight: 800;
    left: 0;
    line-height: ${btnSquare};
    position: absolute;
    right: 0;
    text-align: center;
    top: 0;
    transition: color ${props => props.theme.transition.durationLong}
        ${props => props.theme.transition.easeInOut},
      background ${props => props.theme.transition.durationLong}
        ${props => props.theme.transition.easeInOut};
  }

  &:focus {
    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.1);
  }

  &.open {
    &::before {
      color: ${props => props.theme.colors.tertiary};
      content: 'X';
    }

    circle {
      fill: rgba(0, 0, 0, 0);
      stroke-dashoffset: 1000;
    }

    &:hover {
      circle {
        stroke: ${props => props.theme.colors.tertiary};
        stroke-dashoffset: 0;
      }
    }
  }

  &:hover {
    box-shadow: 0 0 0 5px rgba(255, 255, 255, 0.075);
    transform: scale(1.1);

    circle {
      stroke: ${props => props.theme.colors.tertiary};
      stroke-dashoffset: 0;
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    right: 40px;
    top: 40px;
  }
`;

export default HeaderNavToggleStyled;



// WEBPACK FOOTER //
// ./src/components/atoms/HeaderNavToggle/HeaderNavToggle.styled.js